import React from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { TranslationKeys } from "../../../../constants/TranslationKeys";
import EahsForm from "../../../../components/EahsForm";
import FormTextInput from "../../../../components/FormInputs/FormTextInput";
import FormDateInput from "../../../../components/FormInputs/FormDateInput";
import NetaqInput from "../../../../components/NetaqInput";
import { eformInput, eformCheckBox } from "../../../../common/cssclasses";
import { IBCFieldNames } from "../utils/InternationalBreedingCertificateConstants";
import { useWatch } from "react-hook-form";
import dayjs from "dayjs";

const IBCCoveringSection = ({ isReadOnly = false }) => {
    const { translate } = useTranslate();
    const stallionBirthDateRaw = useWatch({ name: IBCFieldNames.STALLION_BIRTH_DATE_RAW });

    const minCoveringDate = stallionBirthDateRaw || undefined;
    const maxCoveringDate = dayjs().format("YYYY-MM-DD");

    return (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.COVERING_DETAILS, 'Covering Details')}>
            <label className="capatalize_text">
                {translate(TranslationKeys.TYPE_OF_COVERING, "Type Of Covering")}
            </label>
            <div className="row mx-0 mb-form-group">
                <div className={eformCheckBox + " w-unset"}>
                    <NetaqInput
                        name={"typeOfCovering"}
                        type={"radioServiceRequest"}
                        value={"ArtificialInseminationLocal"}
                        label={translate(
                            TranslationKeys.ARTIFICIAL_INSEMINATION_LOCAL,
                            "Artificial Insemination (Locally Collected Semen)"
                        )}
                        checked={true}
                        onChange={() => {}}
                        disabled={isReadOnly}
                    />
                </div>
            </div>
            <div className="row mx-0 mb-form-group">
                <div className={eformCheckBox + " w-unset"}>
                    <NetaqInput
                        name={"isFrozenSemen"}
                        type={"radioServiceRequest"}
                        value={"Frozen"}
                        label={translate(TranslationKeys.FROZEN, "Frozen")}
                        checked={true}
                        onChange={() => {}}
                        disabled={isReadOnly}
                    />
                </div>
            </div>
            <div className="row">
                <div className={eformInput}>
                    <FormTextInput
                        name={IBCFieldNames.TRANSPORTED_STORED_SEMEN_CERT_SERIAL_NO}
                        label={translate(
                            TranslationKeys.SEMEN_DOSE_OWNERSHIP_REFERENCE_NUMBER,
                            'Transported / Stored Semen Certificate Serial Number'
                        )}
                        disabled
                    />
                </div>
                <div className={eformInput}>
                    <FormDateInput
                        name={IBCFieldNames.LAST_COVERING_DATE}
                        label={translate(TranslationKeys.COVERING_DATE, 'Covering Date')}
                        required
                        disabled={isReadOnly}
                        minDate={minCoveringDate}
                        maxDate={maxCoveringDate}
                    />
                </div>
            </div>
        </EahsForm>
    );
};

export default IBCCoveringSection;
